const AjaxPanels = (
    panelContainerId: string,
    panelContentId: string,
    callback?: () => void,
) => {
    const panelContainer = document.getElementById(panelContainerId);
    const panelContent = document.getElementById(panelContentId);

    if (!panelContainer) {
        console.warn(`Panel container with id "${panelContainerId}" not found.`);
        return;
    }

    if (!panelContent) {
        console.warn(`Panel container with id "${panelContentId}" not found.`);
        return;
    }

    // Function to deactivate all buttons
    const deactivateAllButtons = () => {
        const allButtons =
            panelContainer.querySelectorAll<HTMLButtonElement>('.js-btn-tab-nav');
        allButtons.forEach(button => {
            button.classList.remove('active'); // Remove the active class from all buttons
        });
    };

    // Function to toggle the panel visibility with optional callback
    const loadContent = async (panelUrl: string) => {
        //load ajax stuff here
        try {            
            // Perform the fetch operation
            const response = await fetch(panelUrl);

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const htmlContent = await response.text(); // Get HTML as a string
            // Process the fetched data and update the panel content
            panelContent.innerHTML = htmlContent; // Example: setting content from fetched data

            if (callback) {
                callback();
            }
        } catch (error) {
            console.error('Failed to load content:', error);
        }
    };

    // Event handler for panel buttons
    const handlePanelClick = (event: Event) => {
        event.preventDefault();
        const panelBtn = event.target as HTMLButtonElement;

        if (panelBtn.classList.contains('active')) {
            return; // Exit if the clicked button is already active
        }

        const panelUrl = panelBtn.dataset.target;

        if (panelUrl) {
            deactivateAllButtons(); // Remove the active class from all buttons
            panelBtn.classList.add('active'); // Add the active class to the clicked button
            loadContent(panelUrl); // Toggle the panel associated with the clicked button
        }
    };

    // Initialize by adding event listeners to all buttons with the class 'js-btn-tab-nav'
    const initPanels = () => {
        const panelBtns =
            panelContainer.querySelectorAll<HTMLButtonElement>('.js-btn-tab-nav');
        panelBtns.forEach(panelBtn => {
            panelBtn.addEventListener('click', handlePanelClick);
        });
    };

    initPanels();
};

export default AjaxPanels;
